"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var style_utils_1 = require("@nef/style-utils");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var PopoverHeader_1 = __importDefault(require("../../../PopoverHeader"));
var Sidebar_1 = require("../../../Sidebar");
var BaseAvatar_1 = __importDefault(require("../../../Avatar/components/BaseAvatar"));
var innerFunction = function (_a) {
    var iconClassName = _a.iconClassName, iconSetClassName = _a.iconSetClassName, expanded = _a.expanded, innerAs = _a.innerAs, isUserButton = _a.isUserButton, props = __rest(_a, ["iconClassName", "iconSetClassName", "expanded", "innerAs", "isUserButton"]);
    return (react_1.default.createElement(PopoverHeader_1.default, __assign({ as: innerAs }, props)));
};
var StyledSidebarPopoverHeader = styled_components_1.default(innerFunction)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n\n  ", "\n\n  ", " {\n    ", ";\n    height: 38px;\n    width: 38px;\n  }\n"], ["\n  background-color: ", ";\n  color: ", ";\n\n  ",
    "\n\n  ", " {\n    ", ";\n    height: 38px;\n    width: 38px;\n  }\n"])), style_utils_1.getSidebarColor(0), style_utils_1.getSidebarColor(500), function (props) {
    return props.isUserButton && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      align-items: center;\n      color: ", ";\n      border-bottom: 1px solid ", ";\n      max-height: initial;\n      ", ";\n      ", ";\n      font-size: 1.25rem;\n      font-weight: 400;\n      line-height: 1.75rem;\n    "], ["\n      align-items: center;\n      color: ", ";\n      border-bottom: 1px solid ", ";\n      max-height: initial;\n      ", ";\n      ", ";\n      font-size: 1.25rem;\n      font-weight: 400;\n      line-height: 1.75rem;\n    "])), style_utils_1.getSidebarColor(800), style_utils_1.getSidebarColor(50), style_utils_1.setMargin("bottom", 2), style_utils_1.setPadding("bottom", 2));
}, BaseAvatar_1.default, style_utils_1.setMargin("right", 3));
var SidebarPopoverHeader = function (_a) {
    var children = _a.children, innerAs = _a.innerAs, isUserButton = _a.isUserButton, props = __rest(_a, ["children", "innerAs", "isUserButton"]);
    var expanded = react_1.default.useContext(Sidebar_1.SidebarContext).expanded;
    return (react_1.default.createElement(StyledSidebarPopoverHeader, __assign({}, props, { isUserButton: isUserButton, innerAs: isUserButton ? "h3" : innerAs, expanded: expanded }), children));
};
exports.default = SidebarPopoverHeader;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map